export default "__VITE_ASSET__DnN$Igkj__"